import SettingPrice from "./SettingPrice";
export default SettingPrice;
